<template>
  <div>
    <el-upload
      name="file"
      class="avatar-uploader file-list-horizontal"
      :show-file-list="true"
      multiple
      :headers="{'Authorization': 'Bearer ' + token}"
      :action="uploadAction"
      :on-preview="handlePreview"
      :on-change="handleChange"
      :accept="acceptType()"
      :on-remove="handleRemove"
      list-type="picture-card"
      :before-upload="compressBeforeUpload"
      :before-remove="beforeRemove"
      :limit="fileLimit"
      :on-exceed="handleExceed"
      :file-list="fileListAnswer">
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import Compressor from 'compressorjs'
import config from '@/config'

export default {
  computed: {
    ...mapGetters(['token', 'imgUrlGetter', 'cdnGetter']),
    uploadAction () {
      return `${config.BASE_SERVER_PATH}/upload`
    }
  },
  data () {
    return {
      disabled: false,
      fileListAnswer: [],
      fileList: [],
      isShow: false,
      fileTitle: '',
      fileTitleAnswer: 'Та хариултын файлыг хуулна уу',
      fileLimit: 50,
      compressOptions: {
        quality: 0.3, // 30% чанар (маш хүчтэй шахалт)
        maxWidth: 1280, // Илүү жижигрүүлэх
        maxHeight: 720, // HD resolution хүртэл
        convertSize: 0, // Бүх файлыг шахах
        convertTypes: ['image/png', 'image/jpeg'], // Бүх төрлийг JPEG болгох
        mimeType: 'image/jpeg' // Гаралтыг JPEG-рүү хүчлэн хөрвүүлэх
      }
    }
  },
  watch: {
    imgUrlGetter: {
      handler (value) {
        const inFlight = (this.fileListAnswer || []).some(
          f => f.status === 'ready' || f.status === 'uploading'
        )
        if (inFlight) return

        const normalized = this.normalizePaths(value)
        const timestamp = Date.now()
        this.fileListAnswer = normalized.map((path, index) => ({
          name: path.split('/').pop() || `image-${index}`,
          status: 'success',
          uid: `${timestamp}-${index}`,
          url: path.startsWith('http') ? path : `${this.cdnGetter}${path}`,
          response: { data: { location: path } }
        }))
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions(['replaceDynamicImgUrl']),

    normalizePaths (value) {
      if (!value) return []
      return (Array.isArray(value) ? value : [value]).filter(Boolean)
    },

    compressBeforeUpload (file) {
      return new Promise((resolve, reject) => {
        if (file.type.includes('image')) {
          // eslint-disable-next-line no-new
          new Compressor(file, {
            ...this.compressOptions,
            success (result) {
              resolve(new File([result], file.name, {
                type: result.type,
                lastModified: Date.now()
              }))
            },
            error (err) {
              console.error('Image compression error:', err)
              reject(err)
            }
          })
        } else {
          resolve(file)
        }
      })
    },

    syncCompletedUrlsFromFileList (fileList) {
      const successUrls = fileList
        .filter(f => f.status === 'success' && f.response && f.response.data && f.response.data.location)
        .map(f => f.response.data.location)
      const unique = [...new Set(successUrls)]
      if (unique.length || fileList.length === 0) {
        this.replaceDynamicImgUrl(unique)
      }
    },

    handleChange (file, fileList) {
      const hasInProgress = fileList.some(
        f => f.status === 'ready' || f.status === 'uploading'
      )
      this.$root.fullScreenLoading = hasInProgress
      this.fileListAnswer = fileList
      this.syncCompletedUrlsFromFileList(fileList)
    },

    acceptType () {
      return 'image/png, image/jpeg'
    },

    async handleRemove (file, fileList) {
      const location = file.response?.data?.location || file.response || (file.url ? file.url.replace(this.cdnGetter, '') : null)
      if (!location) {
        this.fileListAnswer = fileList
        this.syncCompletedUrlsFromFileList(fileList)
        this.$root.fullScreenLoading = fileList.some(
          f => f.status === 'ready' || f.status === 'uploading'
        )
        return
      }
      try {
        const response = await axios.post(`${config.BASE_SERVER_PATH}/deleteFile`, {
          bucketName: 'daagiigaadskycargo',
          fileName: location
        })

        console.log('Устгах хүсэлтийн хариу:', response.data)

        this.fileListAnswer = fileList
        this.syncCompletedUrlsFromFileList(fileList)
        this.isShow = this.fileListAnswer.length > 0
      } catch (error) {
        console.error('Зураг устгах үед алдаа гарлаа:', error)
      }
    },

    beforeRemove (file, fileList) {
      return this.$confirm(`Сонгосон ${file.name} файлыг хавсаргасан файлын жагсаалтаас хасах уу?`)
    },

    handlePreview (file) {
      console.log(file)
    },

    handleExceed (files, fileList) {
      this.$message.warning(
        `Файл тоо хэтэрсэн байна. ${files.length} файл хуулсан байна. ${this.fileLimit} хэтрэхгүй файл хуулна уу.`
      )
    },

    handleUploadVariantfulImages (file, fileList) {
      this.fileList = fileList
    }
  }
}
</script>

<style>
.avatar-uploader {
  display: block;
  overflow-y: scroll;
  max-height: 400px;
}
.file-list-horizontal {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.file-list-horizontal img {
  display: block;
  margin-bottom: 10px;
}
.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}
.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}
.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}
</style>
